import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: 'input[krosDigitsOnly]',
  host: {
    '[attr.inputmode]': '"numeric"',
  },
  standalone: false,
})
export class DigitsOnlyDirective {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  // prevents individual invalid inputs from user (e.g. typing letters)
  @HostListener('beforeinput', ['$event']) onBeforeInput(event: InputEvent): void {
    if (event.inputType === 'insertText') {
      const data = event.data ?? '';

      if (!/^\d*$/.test(data)) {
        event.preventDefault();
      }
    }
  }

  // sanitizes copy-paste, drag&drop and other forms of input
  @HostListener('input') onInput(): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const inputValue = inputElement.value;
    const newValue = inputValue.replace(/\D/gi, '');

    if (newValue !== inputValue) {
      this.renderer.setProperty(inputElement, 'value', newValue);
      inputElement.dispatchEvent(new Event('input'));
    }
  }
}
